import { render, staticRenderFns } from "./ShowPurchaseOrder.vue?vue&type=template&id=67c6050d&lang=pug&"
import script from "./ShowPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./ShowPurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./ShowPurchaseOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShowPurchaseOrder.vue"
export default component.exports